/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Previous HighSchool View Model
    // Holds the previous HighSchool details
    /**************************************/
    function PreviousHighSchoolViewModel() {

        // Self-Identification
        var self = this;
        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        this.StepID = ko.observable(-1);
        this.sectionIncluded = ko.observable(false);
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Countries = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        self.IsAPASApplicant = ko.observable();
        self.CoursesCountForAPASApplicant = ko.observable(0);

        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {

            if (this.DataList().length > 0) {
                for (var i = 0; i < this.DataList().length; i++) {
                    var dataItem = this.DataList()[i];

                    if (dataItem.HighSchoolID() > 0) return true;
                    var customRet = sm.portal.vm.custom.callCustomization('UpdatedAnythingPopulatedReturn',dataItem);
                    if(customRet) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.HighSchoolName())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.City())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Courses())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.HighestLevelAchieved())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Credentials())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.GPA())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.GPAScale())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.StartDate())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.EndDate())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.GraduatedFlag())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.GraduationDate())) return true;
                    if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) return sm.portal.vm.euhighschool.AnythingPopulated();
                    if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) return sm.portal.vm.ukhighschool.AnythingPopulated();
                }
            }
            return false;
        }, this);
        this.Completed = ko.observable(false);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("HighSchoolContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.sectionVisibleByConfig = ko.observable(null);
        this.UpdateTemplateProperties = {
            HideGPA : ko.observable(false),
            UpdateClearHighSchoolId : ko.observable(false),
            HideCity : ko.observable(false),
            HideCountry : ko.observable(false),
            HighSchoolGraduatedTemplate : ko.observable(''),
            SummaryHighSchoolTemplate : ko.observable('')
        }
        sm.portal.vm.custom.setCustomLocalizeKey(self.UpdateTemplateProperties);
        /*** SECTION PROPERTIES ***/

        /** ADD/EDIT LIST METHODS **/
        this.WorkingItem = ko.observable(new sm.portal.vm.HighSchoolDataItem());
        this.OriginalItem = ko.observable(new sm.portal.vm.HighSchoolDataItem());
        sm.portal.vm.custom.callCustomization('UpdatedListMethods',self);


        this.SaveWorkingChanges = function () {
            var workingItem = self.WorkingItem().Clone();
            var customData = {
                workingItem: workingItem,
                self: self
            }
            var updatedWorkingItem = sm.portal.vm.custom.callCustomization('UpdatedSaveWorkingChanges', customData, 
                function(){
                    if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.SaveWorkingChangesSetupWI(self, workingItem);
                    if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.SaveWorkingChangesSetupWI(self, workingItem);
                    self.WorkingItem(new sm.portal.vm.HighSchoolDataItem());
                }
            );
            if(!sm.portal.utility.isNullOrEmpty(updatedWorkingItem)){
                workingItem = updatedWorkingItem;
            }


            if (workingItem.IsVMValid()) {
                sm.portal.vm.custom.callCustomization('UpdatedReadMode',workingItem);
                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                    self.Completed(true);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    workingItem.InEditMode(false);
                    self.OriginalItem().HighSchoolID(workingItem.HighSchoolID());
                    self.OriginalItem().HighSchoolName(workingItem.HighSchoolName());
                    self.OriginalItem().City(workingItem.City());
                    self.OriginalItem().Courses(workingItem.Courses());
                    self.OriginalItem().HighestLevelAchieved(workingItem.HighestLevelAchieved());
                    self.OriginalItem().Credentials(workingItem.Credentials());
                    self.OriginalItem().GPA(workingItem.GPA());
                    self.OriginalItem().GPAScale(workingItem.GPAScale());
                    self.OriginalItem().StartDate(workingItem.StartDate());
                    self.OriginalItem().EndDate(workingItem.EndDate());
                    self.OriginalItem().GraduatedFlag(workingItem.GraduatedFlag());
                    self.OriginalItem().GraduationDate(workingItem.GraduationDate());
                    self.OriginalItem().InEditMode(workingItem.InEditMode());
                    self.OriginalItem().ID(workingItem.ID());
                    self.OriginalItem().GID(workingItem.GID());
                    var cusData = {
                        workingItem: workingItem,
                        self: self
                    }
                    sm.portal.vm.custom.callCustomization('UpdatedWIprops',cusData,function(){
                        self.DataList.replace(self.OriginalItem(), workingItem);

                        if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.SaveWorkingChangesWIEdit(self, workingItem);
                        if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.SaveWorkingChangesWIEdit(self, workingItem);
                    });

                    
                }
                sm.portal.ui.comboBox();

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
                sm.portal.vm.custom.callCustomization('FocusArea');
            }
        };

        this.GetCountryNameById = function (id) {

            for (var i = 0; i < self.Countries().length; i++) {
                if (self.Countries()[i].Value() === id) {
                    return self.Countries()[i].Text();
                }
            }
            return "";
        }

        this.CancelWorkingChanges = function () {
            self.WorkingItem(new sm.portal.vm.HighSchoolDataItem());

            //hide the display view
            jQuery('.dataEntryView').hide();

            // show the entry view
            jQuery('.dataDisplayView').show();
            sm.portal.vm.custom.callCustomization('ApplicationContentArea');
        };
        this.EditItem = function (data, event) {
            data.enableSchoolAddressFields = ko.observable(true);
            self.OriginalItem(data);
            self.WorkingItem(data.Clone());
            var cusData = {
                data: data,
                self: self
            }
            sm.portal.vm.custom.callCustomization('UpdatedEditItem',cusData,function(){
                if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.EditItem(self, data);
                if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.EditItem(self, data);
            });
          

            self.WorkingItem().InEditMode(true);

            jQuery('.dataDisplayView').hide();
            jQuery('.dataEntryView').show();

            sm.portal.ui.comboBox();
        };
        this.AddItem = function (data, event) {
            self.WorkingItem(new sm.portal.vm.HighSchoolDataItem());
            sm.portal.vm.custom.callCustomization('UpdatedAddItem',self);
        };
        this.RemoveItem = function (data, event) {
            self.DataList.remove(function (item) { return item.HighSchoolID == data.HighSchoolID });
            if (self.DataList().length == 0 && !sm.portal.utility.isAPASFeatureEnabled()) {
                self.Completed(false);
            }
        };
        /** ADD/EDIT LIST METHODS **/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container) {

            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var toFormat = 'YYYY/MM/DD';

            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("HighSchool", container.Payload.Config, true);
                // To handle inclusion usecase
                var showSection = container.Payload.Config.ShowSection;
                !sm.portal.utility.isNullOrEmpty(showSection) && this.sectionVisibleByConfig(showSection);
            }

            var cusData = {
                container: container,
                self: self
            }
            var updatedSaveWorkingItem = sm.portal.vm.custom.callCustomization('UpdatedLoadModal', cusData);    
            if(!updatedSaveWorkingItem){
                if(self.IsAPASApplicant() == null) {
                    if(container && container.Payload) {
                        self.IsAPASApplicant(container.Payload.IsAPASApplicant ? container.Payload.IsAPASApplicant : false);
                        if(self.IsAPASApplicant()) {
                            let courses = 0;
                            container.Payload.HighSchools.forEach(function(item) {
                                courses+= item.Courses ? item.Courses.length : 0;
                            });
                            self.CoursesCountForAPASApplicant(courses);
                        }
                    }
                }
                if (container != null && container.Payload.HighSchools != null && container.Payload.HighSchools.length > 0) {
                    while (this.DataList().length) this.DataList.pop();
                    for (var i = 0; i < container.Payload.HighSchools.length; i++) {
    
                        var hs = container.Payload.HighSchools[i];
                        var newDataItem = new sm.portal.vm.HighSchoolDataItem({
                            HighSchoolID: hs.HighSchoolID,
                            HighSchoolName: hs.HighSchoolName,
                            City: hs.City,
                            Courses: hs.Courses,
                            HighestLevelAchieved: hs.HighestLevelAchieved ? hs.HighestLevelAchieved : null,
                            Credentials: hs.Credentials,
							CredentialList: hs.CredentialList,
                            GPA: hs.GPA,
                            GPAScale: hs.GPAScale,
                            ClassRank: hs.ClassRank,
                            ClassSize: hs.ClassSize,
                            StartDate: hs.StartDate,
                            EndDate: hs.EndDate,
                            GraduatedFlag: hs.GraduatedFlag,
                            ProjectedGPAVerbal: hs.ProjectedGPAVerbal,
                            ProjectedGPAMath: hs.ProjectedGPAMath,
                            GraduationDate: hs.GraduationDate,
                            ID: hs.ID,
                            GID: hs.GID
                        });

                        if(dateFormat === 'YYYY/MM/DD') {
                            newDataItem.GraduationDate(moment(hs.GraduationDate).format(toFormat));
                        }
                        
                        if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.LoadModelPreDataItem(hs);
                        if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.LoadModelPreDataItem(hs);
                
                        if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.LoadModel(hs, newDataItem, container.Payload);
                        if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.LoadModel(hs, newDataItem, container.Payload);
                        
    
                        self.DataList.push(newDataItem);
                        self.Completed(true);
                    }
                }
                else if (container != null && container.Payload.Application_HighSchoolInformation != undefined) {
                    this.StepID(container.Payload.HighSchoolStep.ID);
                }
                if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.LoadListData(this, container);
                if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.LoadListData(this, container);
            }
            
            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[HighSchoolVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                self.LoadModel(viewModel.allCustomData().HighSchool);
                if (viewModel.allCustomData().HighSchool && viewModel.allCustomData().HighSchool.Payload && viewModel.allCustomData().HighSchool.Payload.HighSchools && viewModel.allCustomData().HighSchool.Payload.HighSchools.length > 0) {
                    self.CheckInclusion(applicationMID, personMID);
                }
                callback && callback(viewModel.allCustomData().HighSchool);
                return;
            }
            if (!this.DataLoaded() && !this.DataLoading()) {
                this.DataLoading(true);
                
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=highschool&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        if (data && data.Payload && data.Payload.HighSchools && data.Payload.HighSchools.length > 0) {
                            self.CheckInclusion(applicationMID, personMID);
                        }
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }



            if (!this.DataLoaded() && !this.DataLoading()) {
                this.DataLoading(true);
                this.LoadModel(null);
            }
        };
        this.CheckInclusion = function (applicationMID, personMID) {
            if(self.sectionIncluded()) return;
            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=highschool&attemptmid={0}', applicationMID);

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    self.sectionIncluded(true);
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'HighSchool', required: false });
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'HighSchool', required: true });
                                break;
                            case "Exclude":
                                sectionsToRemove.push('HighSchool');
                                break;
                        }
                        if (self.sectionVisibleByConfig() === false && (result == "Included" || result == "Required")) {
                            sectionsToAdd = null; // If section is hidden by Configuration, don't add the section
                        }
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {

            var atoList = Array();

            for (var i = 0; i < self.DataList().length; i++) {
                var dataListItem = self.DataList()[i];
                var ato = dataListItem.ExtractATO();
                atoList.push(ko.toJS(ato));
            }

            return atoList;
        };
        /*** SECTION METHODS ***/
        sm.portal.vm.custom.callCustomization('VmValidCheck',self);
        return self;
    };

    /**************************************/
    // Previous High School Data Item
    //  Single High School View Model
    /**************************************/
    function HighSchoolDataItem(options) {
        var defaults = {
            HighSchoolID: '', //0, // Remove due to validation false positive
            HighSchoolName: '',
            City: '',
            Courses: null,
            HighestLevelAchieved: null,
            Credentials: [],
            GPA: '',
            GPAScale: 4,
            StartDate: null,
            EndDate: null,
            GraduatedFlag: true,
            GraduationDate: null,
            SchoolCity: '',
            SchoolCountryID: '',
            InEditMode: false,
            ID: -1,
            GID: null,
            enableSchoolAddressFields: true
        };
        sm.portal.vm.custom.callCustomization('UpdatedDefaults',defaults);
        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;
        var cusParams = {
            settings: settings,
            self: self
        }
        sm.portal.vm.custom.callCustomization('UpdatedHighSchoolDataItem',cusParams)
        this.clearHighSchoolId = function (data) {
            if (data && data() == true) {
                return;
            }
            self.HighSchoolID(null);
            self.HighSchoolID.subscribe(function (newValue) {
                if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.Subscribe(self, newValue);
                if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.Subscribe(self, newValue);
            }, self);
        };

        self.HighSchoolID = ko.validatedObservable(settings.HighSchoolID);
        self.City = ko.observable(settings.City);
        self.Courses = ko.observable(settings.Courses);
        self.HighestLevelAchieved = ko.observable(settings.HighestLevelAchieved);
        self.splitCredentials = ko.pureComputed(function() {
            var credentials = settings.CredentialList;
            if(credentials && credentials.length > 0) {
                credentials = credentials.map((cred) => {
                    return cred.Name;
                }).join(", ");
                return credentials;
            } else {
                return "";
            }
        })
        self.Credentials = ko.observable(settings.Credentials);
        self.HighSchoolName = ko.validatedObservable(settings.HighSchoolName);
        self.GPA = ko.validatedObservable(settings.GPA);
        self.GPAScale = ko.validatedObservable(settings.GPAScale);
        self.StartDate = ko.validatedObservable(settings.StartDate);
        self.EndDate = ko.validatedObservable(settings.EndDate);
        self.MomentStartDate = settings.StartDate ? ko.observable(moment(settings.StartDate).format(sm.resources.portalResource.getValue('DateFormatExample').toUpperCase())) : "";
        self.MomentEndDate = settings.EndDate ? ko.observable(moment(settings.EndDate).format(sm.resources.portalResource.getValue('DateFormatExample').toUpperCase())) : "";
        self.GraduatedFlag = ko.validatedObservable(settings.GraduatedFlag);
        self.GraduationDate = ko.validatedObservable(settings.GraduationDate);
        self.SchoolCity = ko.validatedObservable(settings.SchoolCity);
        self.SchoolCountryID = ko.validatedObservable(settings.SchoolCountryID);
        self.SchoolCountry = ko.validatedObservable(settings.SchoolCountry);
        self.ID = ko.validatedObservable(settings.ID);
        self.GID = ko.validatedObservable(settings.GID);

        self.InEditMode = ko.observable(settings.InEditMode);

        /*** PROPERTIES ***/
        self.enableSchoolAddressFields = ko.observable(settings.enableSchoolAddressFields);
        self.Countries = ko.observableArray();
        self.CountriesDataLoaded = ko.observable(false);
        /*** PROPERTIES ***/
        var cusData = {
            self:self,
            settings:settings
        }
        var customReturn = sm.portal.vm.custom.callCustomization('CheckForGraduation', cusData);
        sm.portal.vm.custom.callCustomization('UpdatedSubsribeHighSchool',self);

        self.HighSchoolID.subscribe(function (newValue) {
            if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.Subscribe(self, newValue);
            if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.Subscribe(self, newValue);
        }, self);
        if (sm.portal.utility.isNullOrEmpty(customReturn))
        {
        /*** SUBSCRIBED PROPERTIES ***/
        self.GraduatedFlag.subscribe(function (newValue) {
            if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.Subscribe(self, newValue);
            if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.Subscribe(self, newValue);
            if (newValue) {
                jQuery("#HighSchoolForm div.field.hsGraduationDate").show();
                jQuery("#HighSchoolForm div.field.hsDateRange").hide();
            } else {
                jQuery("#HighSchoolForm div.field.hsDateRange").show();
                jQuery("#HighSchoolForm div.field.hsGraduationDate").hide();
            }

        }, self);
    }

        /*** SUBSCRIBED PROPERTIES ***/
        /*** EU/UK SPECIFIC DATA ITEMS */
        if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.HighSchoolDataItem(self);
        if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.HighSchoolDataItem(self);
        /** END OF EU/UK SPECIFIC DATA ITEMS */
        self.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var toFormat = 'YYYY-MM-DD';

            var stdHighSchoolInformationModel = new smapi.admissions.HighSchoolInformationModel({
                HighSchoolName: self.HighSchoolName(),
                City: self.City(),
                HighestLevelAchieved: self.HighestLevelAchieved(),
                Credentials: self.Credentials(),
                Courses: self.Courses(),
                HighSchoolID: self.HighSchoolID(),
                GraduationDate: self.GraduationDate() == null ? null : moment(self.GraduationDate(), dateFormat).format(toFormat),
                StartDate: self.StartDate() == null ? null : moment(self.StartDate(), dateFormat).format(toFormat),
                EndDate: self.EndDate() == null ? null : moment(self.EndDate(), dateFormat).format(toFormat),
                GPA: self.GPA(),
                GPAScale: self.GPAScale(),
                Graduated: self.GraduatedFlag(),
                ID: self.ID(),
                GID: self.GID(),
            });

            if(dateFormat === 'YYYY/MM/DD') {
                stdHighSchoolInformationModel.GraduationDate(self.GraduationDate() == null ? null : self.GraduationDate())
                stdHighSchoolInformationModel.StartDate(self.StartDate() ? moment(self.StartDate()).format(toFormat) :null);
                stdHighSchoolInformationModel.EndDate(self.EndDate() ? moment(self.EndDate()).format(toFormat) :null);
            }
                
            var customData = {
                stdHighSchoolInformationModel: stdHighSchoolInformationModel,
                self: self
            }
            var customReturn = sm.portal.vm.custom.callCustomization('UpdatedATOHS',customData);
            /**EU Modifies the stdHighSchoolInformationModel and also returns an extra model */
            if(!sm.portal.utility.isNullOrEmpty(customReturn)){
                return customReturn;
            }
            else{
                if (typeof sm.portal.vm.euhighschool !== 'undefined' && euFeatureEnabled) sm.portal.vm.euhighschool.ExtractATO(self, stdHighSchoolInformationModel);
                if (typeof sm.portal.vm.ukhighschool !== 'undefined' && ukFeatureEnabled) sm.portal.vm.ukhighschool.ExtractATO(self, stdHighSchoolInformationModel);
    
                return stdHighSchoolInformationModel;
            }

        };

        this.Clone = function () {
            return new sm.portal.vm.HighSchoolDataItem({
                HighSchoolID: self.HighSchoolID(),
                HighSchoolName: self.HighSchoolName(),
                City: self.City(),
                Courses: self.Courses(),
                HighestLevelAchieved: self.HighestLevelAchieved(),
                Credentials: self.Credentials(),
                GPA: self.GPA(),
                GPAScale: self.GPAScale(),
                StartDate: self.StartDate(),
                EndDate: self.EndDate(),
                GraduatedFlag: self.GraduatedFlag(),
                GraduationDate: self.GraduationDate(),
                InEditMode: self.InEditMode(),
                ID: self.ID(),
                GID: self.GID(),
            });
        };

        /*** VALIDATION METHODS ***/
        self.HighSchoolID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return !sm.portal.utility.isNullOrEmpty(self.HighSchoolName());
                }
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            notify: 'always'
        });
        self.HighSchoolName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return sm.portal.utility.isNullOrEmpty(self.HighSchoolID());
                }
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        self.GPA.extend({
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            min: {
                params: -9.9999,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GpaMustBeBiggerOrEqual_Key), -9.9999)
            },
            max: {
                params: 9.9999,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GpaMustBeLessOrEqual_Key), 9.9999)
            },
            maxDecimals: {
                params: 5,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_Decimals), '5')
            }
        });
        self.GPAScale.extend({
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            min: {
                params: -10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GpaScaleMustBeBiggerOrEqual_Key), -10)
            },
            max: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GpaScaleMustBeLessOrEqual_Key), 10)
            },
            maxDecimals: {
                params: 6,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_Decimals), '6')
            }
        });
        self.StartDate.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            // only need to attach range validator to one of the dates
            smDateRange: {
                params: { start: this.StartDate, end: this.EndDate },
                message: "Please use a valid date range, with valid dates"
            }
        });
        self.EndDate.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        self.GraduationDate.extend({
            smLocalDate: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        self.SchoolCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.SchoolCity.extend({
            pattern: {
                params: /^[a-zA-Z0-9\.\-\#\,\/ ]+$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInCityValue_Key), '(A-z, 0-9 and (. , - # /)')
            }
        });
        sm.portal.vm.custom.callCustomization('OverrideHighSchoolValidation', self);
        sm.portal.vm.custom.callCustomization('ComputedIsVerifiedHighSchool',self);
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        PreviousHighSchoolViewModel: PreviousHighSchoolViewModel,
        HighSchoolDataItem: HighSchoolDataItem,
    });

})(jQuery);